import { render, staticRenderFns } from "./CreateTaskTemplate.vue?vue&type=template&id=73bc78a6"
import script from "./CreateTaskTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTaskTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports